import { AnyType, EnumMethod } from "../util/types";
import { request } from "./request";

export const getUserToken = (code: string) => {
  const url = `/webLogin/getWebLoginInfo.json?state=${code}`;
  return request({ url });
};

interface listProp {
  pageNum: number | string;
  pageSize: number | string;
}

export const getGroups: (p: listProp) => Promise<AnyType> = (params) => {
  const url = "/groups/myGroups.json";
  return request({
    url,
    method: EnumMethod.Get,
    params,
  });
};

export const getGroupDate: (groupId: string) => Promise<AnyType> = (
  groupId
) => {
  const url = `/groups/myAllLikeSubjects.json?groupId=${groupId}`;
  return request({
    url,
    method: EnumMethod.Get,
    params: {},
  });
};

export const getGroupDateMeeting: (
  groupId: string,
  dateStr: string
) => Promise<AnyType> = (groupId, dateStr) => {
  const url = `/groups/groupWeeklyMeetingHome.json?groupId=${groupId}&dataStr=${dateStr}`;
  return request({
    url,
    method: EnumMethod.Get,
    params: {},
  });
};

//
// 乐捐列表接口：/donate/getDonateRecordsByGroupId.json？groupId=XXX

export const getDonateRecordsByGroupId: (
  groupId: string
) => Promise<AnyType> = (groupId) => {
  const url = `/donate/getDonateRecordsByGroupId.json?groupId=${groupId}`;
  return request({
    url,
    method: EnumMethod.Get,
    params: {},
  });
};

// 设置 确认已支付 接口：/donate/setDonateFinishedById.json？donateRecordId=XXX
export const setDonateFinishedById: (
  donateRecordId: string
) => Promise<AnyType> = (donateRecordId) => {
  const url = `/donate/setDonateFinishedById.json?donateRecordId=${donateRecordId}`;
  return request({
    url,
    method: EnumMethod.Get,
    params: {},
  });
};

// 获取弹窗数据（用户列表、乐捐类型列表）：   /donate/getDonateRecordForm.json?groupId=XXX
export const getDonateRecordForm: (groupId: string) => Promise<AnyType> = (
  groupId
) => {
  const url = `/donate/getDonateRecordForm.json?groupId=${groupId}`;
  return request({
    url,
    method: EnumMethod.Get,
    params: {},
  });
};

// 提交数据：/donate/addDonateRecord.json?groupId=XXX&userId=XXX&donateType=XXX
/**
 *
 * @param groupId
 * @param userId
 * @param donateType
 * @returns
 */
export const addDonateRecord: (p: any) => Promise<AnyType> = (params) => {
  const url = `/donate/addDonateRecord.json`;
  return request({
    url,
    method: EnumMethod.Get,
    params,
    isQuery: true,
  });
};

export const getUserMission: (p: any) => Promise<AnyType> = (params) => {
  const url = `userMission/getMyAllUserMissionsByGroupId.json`;
  return request({
    url,
    method: EnumMethod.Get,
    params,
    isQuery: true,
  });
};

const temp = {};

export default temp;
